module.exports = __webpack_public_path__ + "img/icon-secure.bc69b22f.svg";